import React, {useState} from 'react';
import Stepper from '../common/components/Stepper/Stepper';
import CustomInput from '../common/components/CustomInput/CustomInput';
import Table from '../common/components/ItemTable/v2/Table';
import Button from '../common/components/Button/Button';
import PersonInfoCard from '../common/components/PersonInfoCard/PersonInfoCard';


const Test = () => {
    const [provider, setProvider] = useState(0);

    const handleOnChangeInput = (newValue) => {
        console.log(newValue);
    };
    return (
        <div style={{width: '100vw', height: '100vh', margin: '100px', display: 'flex', flexDirection: 'row', backgroundColor: '#fff'}}>
            <div style={{height: '100%', margin: '40px'}}>
                <PersonInfoCard fullName={'Christian Cerella'} attributes={['DNI: 12345678', 'Edad: 30', 'Sexo: Masculino']}/>
            </div>
        </div>
    );
};
export default Test;
